(function () {
  'use strict';

  /* @ngdoc object
   * @name vcpatdocs
   * @description
   *
   */
  angular
    .module('vcpatdocs', [
      'ui.router',
      'ui.tinymce',
      'ui.bootstrap'
    ]);
}());
